export const ERROR_RECEIVER = "receiver"
